import ScopeChangeRequest from 'admin/scope-change-requests/ScopeChangeRequest'
import ScopeChangeRequestStore from 'admin/ScopeChangeRequestStore'
import ModalViewModel from 'infra/ModalViewModel'
import { action, computed, makeObservable, observable } from 'mobx'
import { task } from 'mobx-task'
import { maxLength, minLength } from 'utils/validation-utils'
import { validationContext } from 'validx'

export default class ScopeChangeRequestRejectOnBehalfOfClientViewModel extends ModalViewModel {
  @observable scopeChangeRequest = ScopeChangeRequest.none
  /**
   * The reason the request was rejected
   */
  @observable reason = ''

  readonly MAX_REASON_LENGTH = 280 as const

  /**
   * Validation context for reject reason
   */
  readonly validation = validationContext(this, {
    reason: [
      minLength(1, 'Reason must not be empty.'),
      maxLength(
        this.MAX_REASON_LENGTH,
        `Reason must be less than ${this.MAX_REASON_LENGTH} characters`,
      ),
    ],
  })

  constructor(
    private scopeChangeRequestStore: ScopeChangeRequestStore,
    private refreshStatusFilter: () => Promise<void>,
  ) {
    super()
    makeObservable(this)
  }

  /**
   * Reason input characters remaining text label.
   */
  @computed
  get reasonCharsRemaining() {
    return this.reason
      ? this.MAX_REASON_LENGTH - this.reason.length
      : this.MAX_REASON_LENGTH
  }

  reset() {
    this.reason = ''
    this.validation.reset()
  }

  /**
   * Set the reason
   */
  @action.bound
  setReason(reason: string) {
    this.reason = reason
  }

  /**
   * Shows the dialog and sets the scope change request
   * @param scopeChangeRequest
   */
  open(scopeChangeRequest: ScopeChangeRequest) {
    this.scopeChangeRequest = scopeChangeRequest
    this.show()
  }

  /**
   * Declines the scope change request
   * @returns
   */
  decline = task.resolved(async () => {
    if (!this.validation.reset().validate().isValid) {
      return
    }

    await this.scopeChangeRequestStore.rejectScopeChangeRequestOnBehalfOfClient(
      this.scopeChangeRequest,
      this.reason,
    )

    await this.refreshStatusFilter()

    this.reset()
    this.close()
  })
}
